import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { RegionContainer } from '../../styles/Utility.styles'

export const PresenterBlock = styled(RegionContainer)`
  grid-column: 2 / 12;
  grid-template-columns: 1fr;
`

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 12px;

  @media ${DEVICE.tabletL} {
    padding-bottom: 20px;
  }
`

export const Photo = styled.img`
  width: 54px;
  height: 54px;
  border-radius: 50%;

  @media ${DEVICE.tabletL} {
    width: 80px;
    height: 80px;
  }
`

export const TextRegion = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
`

export const TextItem = styled.div`
  /* padding-left: 24px; */
  flex: 0 0 100px;
  padding-left: 20px;
  margin-bottom: unset;

  :first-of-type {
    margin-bottom: 10px;
  }

  :last-of-type {
    flex-grow: 1;
  }

  @media ${DEVICE.tabletL} {
    flex: 0 0 189px;
    padding-left: 30px;
    margin-bottom: unset;
  }
`

export const Heading = styled.h5`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 1.6rem;
  text-transform: uppercase;
  color: var(--highlight-blue);

  @media ${DEVICE.tabletL} {
    font-size: 1.4rem;
    line-height: 1.9rem;
  }
`

export const Body = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 1.4rem;
  line-height: 1.9rem;
  color: var(--content-background-dark-blue);
  padding: 4px 0 14px;
  text-decoration-line: none;

  /* :hover {
    text-decoration-line: underline;
  } */

  @media ${DEVICE.tabletL} {
    font-size: 1.8rem;
    line-height: 2.5rem;
  }
`
